import App from './App.vue'
import { createApp } from 'vue'
import router from './router'

// https://stackoverflow.com/questions/65513579/how-do-i-turn-off-the-productiontip-warning-in-vue-3
// Vue.config.productionTip = false

// Vue 2
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')

// Vue 3
createApp(App)
  .use(router)
  .mount('#app')